import { render, staticRenderFns } from "./ChangeParent.vue?vue&type=template&id=253a6710&scoped=true"
import script from "./ChangeParent.vue?vue&type=script&lang=js"
export * from "./ChangeParent.vue?vue&type=script&lang=js"
import style0 from "./ChangeParent.vue?vue&type=style&index=0&id=253a6710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253a6710",
  null
  
)

export default component.exports